import { memo } from 'react';

export const FacebookIcon = memo(() => {
  return (
    <svg
      id="Capa_1"
      version="1.1"
      viewBox="0 0 430.1 430.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <g>
          <path
            d="M158.1,83.3c0,10.8,0,59.2,0,59.2h-43.4v72.4h43.4v215.2h89.1V214.9H307c0,0,5.6-34.7,8.3-72.7     c-7.8,0-67.8,0-67.8,0s0-42.1,0-49.5c0-7.4,9.7-17.4,19.3-17.4c9.6,0,29.8,0,48.6,0c0-9.9,0-43.9,0-75.4c-25,0-53.5,0-66,0     C155.9,0,158.1,72.5,158.1,83.3z"
            id="Facebook"
          />
        </g>
      </g>
    </svg>
  );
});
